/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-05-11 22:06:20
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyTextEditor from "../BsyTextEditor";
import BsyTextTag from "../BsyTextTag";
import { BsyWidget } from "../BsyWidget";
import "./index.css";

class BsyRadioGroup extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-x-group",
    onAfterItemSelect: null,
    onItemCreate: null,
    onStopEdit: null,
    onAfterEdit: null,
    repeatBtn: !1,
    required: !1,
    allowBlank: !0,
    layout: "",
    height: "auto",
    colorEnable: !1,
    otherInputWidth: 180,
    onStateChange: null,
    type: "radiogroup",
    stopCancel: !1, //禁止取消选中状态
  };

  constructor(props) {
    super(props);
    this.otherText = null;
    this.otherTextRef = React.createRef();
    let obj = this.getDefaultValue();
    this.state = {
      prohibit: this.options.prohibit,
      ...props,
      ...obj,
    };
  }

  getValue = () => {
    return this.value;
  };

  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    a.allowBlank || (b = !BsyUtils.isObjectEmpty(this.value));
    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };

  setValue = (value) => {
    this.value = value;
    this.setState({
      value: value,
      items: this.filterData(),
    });
  };

  componentDidMount() {
    super.componentDidMount();
  }

  _doItemClick = (val) => {
    const { items, stopCancel, value, required } = this.state;
    if (required && val.value === value) {
      return;
    }
    let that = this;
    this.selectItem = { ...val }; //告诉当前选择的是那个选项， 不能光靠value来判断
    var newValue = val.value;
    if (!stopCancel) {
      if (value == newValue) {
        newValue = "";
      }
    }

    if (val.isOther) {
      this.selectOther = !this.selectOther;
      if (this.selectOther) {
        newValue = this.otherText;
      } else {
        newValue = "";
      }
    } else {
      this.selectOther = false;
    }

    var newItems = items.map((data, index) => {
      let dt1 = { ...data };
      delete dt1.selected;
      return dt1;
    });
    this.value = newValue;
    this.setState(
      {
        items: newItems,
        value: newValue,
      },
      () => {
        if (this.selectOther == true) {
          setTimeout(() => {
            if (that.otherTextRef) that.otherTextRef.current.focus();
          }, 30);
          BsyUtils.applyFunc(
            this,
            this.props.onStopEdit,
            [this.otherText, this.selectItem, this],
            !1
          );
        } else {
          BsyUtils.applyFunc(
            this,
            this.props.onStopEdit,
            [newValue, this.selectItem, this],
            !1
          );
        }
      }
    );
  };

  otherSelect = (items) => {
    var isSelected = false;
    if (this.hasSelectOther) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].isOther && items[i].selected) {
          this.selectItem = { ...items[i] };
          isSelected = true;
          break;
        }
      }
    }

    return !isSelected;
  };

  _createItem = (item, index) => {
    const { layout } = this.options;
    const { value } = this;
    if (item.isOther) {
      if (this.selectOther && !this.selectItem) {
        this.selectItem = { ...item };
      }

      return (
        <div
          className={
            "bsy-group-item x-radio other " +
            layout +
            (this.selectOther ? " select" : "")
          }
          key={"radio-item-" + index}
          onClick={(e) => {
            if (e.target.classList.contains("x-input")) {
              e.stopPropagation();
              e.preventDefault();
              return false;
            }
            this._doItemClick(item);
          }}
        >
          <i className="icon-bsy-icondanxuananniu"></i>

          {this.props.colorEnable ? (
            <>
              {item.color ? (
                <BsyTextTag
                  customCls={" middle single-line"}
                  text={item.text}
                  color={item.color}
                >
                  {" "}
                </BsyTextTag>
              ) : (
                <span
                  className="bsy-text-tag  middle single-line"
                  style={{ color: "#333", background: "#f5f6f7" }}
                >
                  {item.text}
                </span>
              )}
            </>
          ) : (
            <span>{item.text}</span>
          )}
          <BsyTextEditor
            ref={this.otherTextRef}
            value={this.otherText}
            waterMark={React.language("content.type")}
            // enable={this.selectOther}
            height={34}
            onAfterEdit={(val) => {
              this.otherText = val;
              this.value = val;

              BsyUtils.applyFunc(
                this,
                this.props.onAfterEdit,
                [val, this.selectItem, this],
                !1
              );
            }}
            onStopEdit={(val) => {
              this.otherText = val;
              this.value = val;
              BsyUtils.applyFunc(
                this,
                this.props.onStopEdit,
                [val, this.selectItem, this],
                !1
              );
              BsyUtils.applyFunc(
                this,
                this.props.onAfterEdit,
                [val, this.selectItem, this],
                !1
              );
            }}
          ></BsyTextEditor>
        </div>
      );
    } else {
      return (
        <div
          className={
            "bsy-group-item x-radio " +
            layout +
            (item.value === value ? " select" : "")
          }
          key={"radio-item-" + index}
          onClick={() => {
            this._doItemClick(item);
          }}
        >
          <i className="icon-bsy-icondanxuananniu"></i>

          {this.props.colorEnable ? (
            <>
              {item.color ? (
                <BsyTextTag
                  customCls={" middle single-line"}
                  text={item.text}
                  color={item.color}
                >
                  {" "}
                </BsyTextTag>
              ) : (
                <span
                  className="bsy-text-tag  middle single-line"
                  style={{ color: "#333", background: "#f5f6f7" }}
                >
                  {item.text}
                </span>
              )}
            </>
          ) : (
            <span>{item.text}</span>
          )}
        </div>
      );
    }
  };

  rebuild = () => {
    console.log("--- radiogroup rebuild bsy-ui-hidden ---");
    this.options.cssName = this.options.baseCls + " " + this.options.widgetName;
    if (!this.isEnabled()) {
      this.options.cssName += " bsy-ui-disable";
    }
    if (!this.isVisible()) {
      this.options.cssName += " bsy-ui-hidden";
    }

    if (this.options.customCls) {
      this.options.cssName += " " + this.options.customCls;
    }

    this.options.css = {};
    if (this.options.height) this.options.css.height = this.options.height;
    if (this.options.width) this.options.css.width = this.options.width;
    // this.options.css.lineHeight = this.options.lineHeight + 'px';
    this.value = this.options.value;
    let obj = this.getDefaultValue();
    this.setState(obj);
  };

  renderDisablePane = () => {
    const { value } = this;
    return (
      <div
        className="bsy_form_item_disable"
        data-watermark={React.language("content.empty")}
        title={value}
      >
        {value ? value : ""}
      </div>
    );
  };

  render() {
    const { items, layout } = this.state;
    const { cssName, css } = this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane(items);
    }
    return (
      <div className={cssName + " " + layout} style={css} ref={this.element}>
        {items &&
          items.map((item, index) => {
            return this._createItem(item, index);
          })}
      </div>
    );
  }
}

export default BsyRadioGroup;
